<script setup lang="ts">
import Sidebar from "./Sidebar.vue";
import MobileNav from "./MobileNav.vue";
import BaseLayout from "./BaseLayout.vue";
import SearchDialog from "@/components/searchDialog/SearchDialog.vue";
import { useContentStore } from "@/stores/contentStore";
import { useMediaQuery } from "@vueuse/core";
import { DialogRoot } from "reka-ui";
import DialogContent from "@/components/DialogContent.vue";

const isLargeScreen = useMediaQuery("(min-width: 768px)");
const contentStore = useContentStore();
</script>

<template>
  <BaseLayout>
    <div class="md:pl-72">
      <Sidebar v-if="isLargeScreen" />
      <MobileNav v-else />
      <main>
        <router-view />
      </main>
    </div>
    <DialogRoot v-model:open="contentStore.showSearchModal">
      <DialogContent size="lg" :openAutoFocus="false">
        <SearchDialog />
      </DialogContent>
    </DialogRoot>
  </BaseLayout>
</template>
